import SearchInput from '../../common/SearchInput/SearchInput'
import './DashHeader.css'
import { useTranslation } from 'react-i18next';
function DashHeader({header , children , btnFn , getSearchValue}){
  const { t } = useTranslation();
  return(
    <div className="dashHeader-container">
      <h2>{header}</h2>
      <div>
        <SearchInput getSearchValue = {getSearchValue}/>
        {
          btnFn&&
        <button onClick={btnFn}>{t('add')}</button>
        }
      </div>
    </div>
  )
}
export default DashHeader